import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
export function Badge({ className, children, ...rest }) {
    return (_jsx("span", { "data-slot": "badge", className: cn("inline-flex items-center rounded-pill bg-ink-100 px-2 py-0.5 text-caption font-medium text-ink-700", className), ...rest, children: children }));
}
